import React from 'react'
import PropTypes from 'prop-types'
import { Categories } from './Categories'
import { Filters } from './Filters'

import './style.css.scss'

const Header = ({
  categories,
  categoryIds,
  categoryTheme,
  themeColorHex,
  onCategoryClick,
  selectedCategoryId,
  showHomeCategory,
  showSearch,
  board
}) => (
  <div className="items-header">
    <Categories
      board={board}
      showSearch={showSearch}
      categoryTheme={categoryTheme}
      categoryIds={categoryIds}
      categories={categories}
      selectedCategoryId={selectedCategoryId}
      themeColorHex={themeColorHex}
      onCategoryClick={onCategoryClick}
      showHomeCategory={showHomeCategory} />
    <Filters
      categoryIds={categoryIds}
      categories={categories}
      selectedCategoryId={selectedCategoryId}
      themeColorHex={themeColorHex}
      onCategoryClick={onCategoryClick}
      showSearch={showSearch} />
  </div>
)

Header.propTypes = {
  categoryTheme: PropTypes.string.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  selectedCategoryId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  board: PropTypes.object.isRequired,
  categories: PropTypes.object,
  categoryIds: PropTypes.array,
  onCategoryClick: PropTypes.func.isRequired,
  showHomeCategory: PropTypes.bool,
  showSearch: PropTypes.bool
}

export default Header
